var map = {
	"./Cards.svg": "LS8w",
	"./add-document.svg": "lk3r",
	"./admin.svg": "BlLF",
	"./alipay.svg": "3DrL",
	"./back.svg": "RN8c",
	"./back1.svg": "Um8k",
	"./bankCard1.svg": "QS+5",
	"./bankCard10.svg": "HQlR",
	"./bankCard2.svg": "rPQ3",
	"./bankCard3.svg": "bN0V",
	"./bankCard4.svg": "wcUp",
	"./bankCard5.svg": "+oWS",
	"./bankCard6.svg": "IxtB",
	"./bankCard7.svg": "89I0",
	"./bankCard8.svg": "K1Om",
	"./bankCard9.svg": "G+Rq",
	"./bar.svg": "BUXY",
	"./book-open.svg": "1HTL",
	"./box-open.svg": "AyPJ",
	"./brand-verify.svg": "5VEj",
	"./cangku.svg": "DbF2",
	"./cangkuliebiao.svg": "xD2u",
	"./cangkushenhe.svg": "Ds93",
	"./closeWifi.svg": "WAZr",
	"./cms-subject.svg": "zjZS",
	"./cms-topic.svg": "2SiQ",
	"./cms.svg": "fHET",
	"./code.svg": "IX5Q",
	"./coins.svg": "Kxms",
	"./company.svg": "znPN",
	"./creditValue.svg": "KkfT",
	"./creditValueList.svg": "YL2m",
	"./dashboard.svg": "BCGP",
	"./delete.svg": "Imjp",
	"./dingdan-copy.svg": "6U4W",
	"./document.svg": "mDNq",
	"./download.svg": "+H2/",
	"./email.svg": "+4G4",
	"./entry.svg": "u/vw",
	"./entry1.svg": "MnWJ",
	"./example.svg": "OOLB",
	"./excel.svg": "OLl3",
	"./eye-open.svg": "no6o",
	"./eye.svg": "4wdf",
	"./fa-box.svg": "H+39",
	"./fa-boxes.svg": "Fxnc",
	"./fa-calendar-check.svg": "o7TC",
	"./fa-cart-shopping.svg": "OaIn",
	"./fa-check-circle.svg": "CJ45",
	"./fa-exclamation-triangle.svg": "b7lo",
	"./fa-folder-open.svg": "fKyA",
	"./fa-gears.svg": "Zhod",
	"./fa-hourglass-half.svg": "Rduh",
	"./fa-house.svg": "OWBf",
	"./fa-palette.svg": "PJQI",
	"./fa-pen-fancy.svg": "EqGX",
	"./fa-pound-sign.svg": "d54h",
	"./fa-th-list.svg": "apkK",
	"./fa-user-tie.svg": "Azs1",
	"./fa-users.svg": "+CNl",
	"./fa-warehouse.svg": "OwQR",
	"./fa-wrench.svg": "Dr7G",
	"./fa_box.svg": "eKrp",
	"./fa_boxes.svg": "xoQ+",
	"./fa_circle-pound-sterling.svg": "z8X2",
	"./fa_contact.svg": "teRW",
	"./fa_credit-card.svg": "1gcn",
	"./fa_file-pen.svg": "AuOp",
	"./fa_fund.svg": "nFQh",
	"./fa_heart-handshake.svg": "iUEy",
	"./fa_home.svg": "V/Cg",
	"./fa_house.svg": "5CtI",
	"./fa_order.svg": "yGlC",
	"./fa_package.svg": "ABtJ",
	"./fa_plus.svg": "pAh2",
	"./fa_product.svg": "PRuN",
	"./fa_receipt-cent.svg": "PFkm",
	"./fa_receipt-pound-sterling.svg": "M+SG",
	"./fa_scroll.svg": "vowb",
	"./fa_shopping-bag.svg": "htNp",
	"./fa_user-cog.svg": "zi8X",
	"./fa_users.svg": "M7b1",
	"./fa_wallet.svg": "du+t",
	"./fa_warehouse.svg": "+Q8Y",
	"./fi-rr-cloud-download-alt.svg": "ZRfp",
	"./fi-rr-download.svg": "BkDx",
	"./fi-rr-plus-small.svg": "k7VB",
	"./fi-rr-upload.svg": "9xhr",
	"./fi-sr-boxes.svg": "8C/L",
	"./fi-sr-cart-shopping-fast.svg": "aJyj",
	"./fi-sr-circle.svg": "1B0h",
	"./fi-sr-cloud-download-alt.svg": "Yrw6",
	"./fi-sr-coins.svg": "IgA2",
	"./fi-sr-credit-card.svg": "dcnr",
	"./fi-sr-envelope.svg": "RT3P",
	"./fi-sr-gears.svg": "rBLO",
	"./fi-sr-home.svg": "DSw7",
	"./fi-sr-list-dropdown.svg": "Vu/Y",
	"./fi-sr-paper-plane.svg": "IHXz",
	"./fi-sr-seller.svg": "+b5e",
	"./fi-sr-shipping-fast.svg": "tDAV",
	"./fi-sr-user-gear.svg": "qwVe",
	"./fi-sr-users-alt.svg": "nLrf",
	"./fi-sr-warehouse-alt.svg": "rQLg",
	"./fi-ss-check-circle.svg": "ShnR",
	"./fi-ss-lock.svg": "yvkL",
	"./fi-ss-shield-check.svg": "hLzX",
	"./file-edit.svg": "UArW",
	"./file-invoice-dollar.svg": "ocXq",
	"./fold.svg": "5pIo",
	"./fr-rr-cloud-upload-alt.svg": "o8AF",
	"./frame.svg": "IPab",
	"./headset.svg": "Q2fc",
	"./home.svg": "U9Ws",
	"./huobi.svg": "PyRl",
	"./image.svg": "dDyW",
	"./isCheck.svg": "cBjV",
	"./jiesuanzhouqi.svg": "zfKT",
	"./line-file-pound.svg": "aUWz",
	"./line.svg": "9xjd",
	"./link-file.svg": "ZMOK",
	"./link.svg": "KgwQ",
	"./list-dropdown.svg": "jDJD",
	"./login-mall.svg": "xzZT",
	"./lunbotu.svg": "Oz9N",
	"./menu.svg": "dH9r",
	"./menu/circularWarehouse.svg": "sHAJ",
	"./menu/dashboard.svg": "Yw9x",
	"./menu/form.svg": "qFrK",
	"./menu/marker.svg": "yWeb",
	"./menu/order.svg": "52vv",
	"./menu/poundSymbol.svg": "OAYK",
	"./menu/securityLock.svg": "FNoq",
	"./menu/settingsOption.svg": "ap4v",
	"./menu/shoppingBag.svg": "GST1",
	"./menu/userIcon.svg": "h5ic",
	"./menu/warehouse.svg": "ff2J",
	"./message.svg": "G2zY",
	"./order-return-reason.svg": "PeRC",
	"./order-return.svg": "vigK",
	"./order-setting.svg": "LpN3",
	"./order.svg": "gYtG",
	"./orderClose.svg": "1ME1",
	"./orderComplete.svg": "4iq6",
	"./orderPedding.svg": "2WRl",
	"./password.svg": "QjmH",
	"./pdf.svg": "M8Oc",
	"./pound.svg": "UYMC",
	"./product-add.svg": "Cuqr",
	"./product-attr.svg": "Aain",
	"./product-brand.svg": "JTBo",
	"./product-cate.svg": "G6Qz",
	"./product-comment.svg": "b5pz",
	"./product-list.svg": "qzoa",
	"./product-recycle.svg": "WSWy",
	"./product.svg": "UHi4",
	"./refresh.svg": "SLu3",
	"./review.svg": "3epJ",
	"./search.svg": "Bx0U",
	"./shangpinshenhe.svg": "6sSM",
	"./shelve.svg": "kNM7",
	"./shenpi.svg": "ATbL",
	"./sms-ad.svg": "2epx",
	"./sms-coupon.svg": "0Kk2",
	"./sms-flash.svg": "/KjT",
	"./sms-hot.svg": "If2y",
	"./sms-new.svg": "vvoC",
	"./sms-subject.svg": "4H1Q",
	"./sms.svg": "AS+9",
	"./spec.svg": "TfIM",
	"./table.svg": "oSYw",
	"./total-today.svg": "le/7",
	"./total-week.svg": "csmh",
	"./total-yesterday.svg": "C15R",
	"./transfer.svg": "S35e",
	"./tree.svg": "3eCm",
	"./txt.svg": "YXXy",
	"./ums-admin.svg": "FR/6",
	"./ums-menu.svg": "sr5k",
	"./ums-resource.svg": "noU8",
	"./ums-role.svg": "w7oB",
	"./ums.svg": "J4x9",
	"./undo.svg": "0twP",
	"./upload.svg": "P/TB",
	"./user-gear.svg": "toFX",
	"./user.svg": "VdD3",
	"./users-alt.svg": "yKzI",
	"./video.svg": "3JNx",
	"./warehouse-alt.svg": "0sfK",
	"./warning.svg": "TcIt",
	"./wechat.svg": "pYJ+",
	"./yanpiaoduizhang.svg": "aEi5",
	"./yonghuliebiao.svg": "pbe1",
	"./zhanghu.svg": "RsZT",
	"./zip.svg": "0DNV"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "eZ11";


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg \.svg$
// module id = eZ11
// module chunks = 36